
<template>
    <div class="center">
      <vs-dialog v-model="active" prevent-close @close="getInfo">
        <template #header>
          <h4 class="not-margin">
            Editar componente
          </h4>
        </template>


        <div class="con-form">
            <vs-row>
                <vs-col sm="12" lg="6">
                    <form autocomplete="off">
                        <label for="institucion" class="labelInput">
                            Institución 
                        </label>
                        <vs-select filter class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" v-if="instituciones.length" :disabled="!instituciones.length" autocomplete="off" @input="getInstituciones()" >
                            <template #message-danger v-if="errorFields.includes('institucion')">
                                Requerido
                            </template>
                            <template v-if="instituciones.length" autocomplete="off">
                                <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </template>
                            <template v-else>
                                <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                </vs-option>
                            </template>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="6">
                    <form autocomplete="off">
                        <label for="cicloEscolar" class="labelInput">
                            Ciclo Escolar
                        </label>
                        <vs-select filter class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar Ciclo Escolar" :key="cicloId" v-model="cicloEscolar" v-if="instituciones.length" :disabled="!ciclosEscolares.length" autocomplete="off">
                            <template #message-danger v-if="errorFields.includes('ciclo')">
                                Requerido
                            </template>
                            <template v-if="ciclosEscolares.length" autocomplete="off">
                                <vs-option v-for="option in ciclosEscolares" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </template>
                            <template v-else>
                                <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                </vs-option>
                            </template>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="6">
                    <form autocomplete="off">
                        <label for="escala_calificaciones" class="labelInput">
                            Escala de calificaciones
                        </label>
                        <vs-select filter class="aqui pt-0" id="escala_calificaciones" placeholder="Escala de calificaciones" :key="escalasId" v-model="escala" :disabled="!escalas.length" autocomplete="off">
                            <template #message-danger v-if="errorFields.includes('escala')">
                                Requerido
                            </template>
                            <template v-if="escalas.length" autocomplete="off">
                                <vs-option v-for="option in escalas" :key="option.id"  :label="option.nombre" :value="option.id">
                                    {{option.nombre}}
                                </vs-option>
                            </template>
                            <template v-else>
                                <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                </vs-option>
                            </template>
                        </vs-select>
                    </form>
                </vs-col>
            <vs-col sm="12" lg="6">
                <form autocomplete="off">
                    <label for="Nombre"  class="labelInput">Nombre</label>
                    <vs-input class="pt-0" id="Nombre" placeholder="Escriba el nombre" v-model="nombre">
                        <template #message-danger v-if="errorFields.includes('nombre')">
                            Requerido
                        </template>
                    </vs-input>
                </form>
            </vs-col>
            </vs-row>
        </div>

        <template #footer>
          <div class="footer-dialog">
              <vs-row>
                  <vs-col sm="12" lg="6">
                    <vs-button
                        danger
                        flat
                        @click="active = false, getInfo()">
                        Cancelar
                    </vs-button>
                  </vs-col>
                  <vs-col sm="12" lg="6">
                    <vs-button
                        success
                        class="ml-auto"
                        @click="getEditarComponentesGeneral()">
                        Guardar
                    </vs-button>
                  </vs-col>
              </vs-row>
          </div>
        </template>
      </vs-dialog>
    </div>
</template>
<script>
import academico from '../../../../../api/requests/academico'
    export default {
        props:[
        'value',
        'row',
        'general',
        'indice',
        'fila'
        ],
        data:() => ({
            active: false,
            institucion: '',
            instituciones: [],
            institucionId: (new Date()).getTime(),
            errorInstituto: false,
            cicloEscolar: '',
            ciclosEscolares: [],
            cicloId: (new Date()).getTime(),
            escala: '',
            escalas:[],
            escalasId:(new Date()).getTime(),
            nombre: '',
            continuar: false,
            errorFields:[],
        }),
        created(){
            this.getInstituciones()
            this.getEscalaCalificaciones()
        },
        methods:{
            async getInstituciones(){
                try {
                    const response = await academico.getInstitucion()
                    this.instituciones = response.data
                }
                catch{

                }
            },
            async getCicloEscolar() {
                const { data: response } = await academico.getCiclosEscolares(this.institucion)
                this.ciclosEscolares = response
                this.cicloId = (new Date()).getTime()
            },
            async getEscalaCalificaciones(){
                try {
                    const response = await academico.getEscalaCalificaciones()
                    this.escalas = response.data
                    this.escalasId = (new Date()).getTime()
                }
                catch{
                    
                }
            },
            getInfo(){
                this.nombre = this.row.nombre
                this.instituciones.forEach(i => {
                    if(i.text === this.row.nombre_institucion){
                        this.institucion = i.id
                    }
                });
                this.ciclosEscolares.forEach(i => {
                    if(i.text === this.row.nombre_ciclo){
                        this.cicloEscolar = i.id
                    }
                });
                this.escalas.forEach(i => {
                    if(i.nombre === this.row.nombre_escala){
                        this.escala = i.id
                    }
                });
            },
            checkByType (type, val) {
                switch (type) {
                    case 'string':
                        if (val && val.constructor.name === 'String' && val.trim()) {
                            return true
                        }
                    case 'number':
                        if (val && val.constructor.name === 'Number' && val > 0) {
                            return true
                        } 
                }
                return false
            },
            sanityForm () {
                this.errorFields = []
                if (!this.checkByType ('string', this.institucion)) {
                    this.errorFields.push('institucion')
                }
                if (!this.checkByType ('string', this.cicloEscolar)) {
                    this.errorFields.push('ciclo')
                }
                if (!this.checkByType ('string', this.escala)) {
                    this.errorFields.push('escala')
                }
                if (!this.checkByType ('string', this.nombre)) {
                    this.errorFields.push('nombre')
                }
                if (!this.errorFields.length){
                    return this.continuar = true
                } else {
                    return this.continuar = false
                }
            },
            async getEditarComponentesGeneral(){
                this.sanityForm()
                if(this.continuar === true){
                    try{
                        const formData = new FormData()
                        formData.append('institucion_id', this.institucion)
                        formData.append('ciclo_escolar_id', this.cicloEscolar)
                        formData.append('escala_calificacion_id', this.escala)
                        formData.append('nombre', this.nombre)
                        const response = await academico.getEditarComponentesGeneral(formData, this.row.id)
                        if(response.status === 200){
                            this.active = false
                            this.$emit('refreshTable')
                            this.$vs.notification({
                                progress: 'auto',
                                color: 'success',
                                position: null,
                                title: 'El componente fue editado con éxito.',
                            })
                        }
                    }catch{

                    }
                }
            },
        },
        watch:{
            
            value (val) {
                this.active = val
            },       
            async active (val) {
                if (!val){
                    this.$emit('input', val);
                }
            },
            row(){
                this.getInfo()
            },
            institucion(){
                this.getCicloEscolar()
                this.getInfo()
            },
            ciclosEscolares(){
                this.getInfo()
            }
        }
    }
</script>
